import { UPDATE_FILTER } from './moreFiltersActions';

const initialState = {
  moreFilters: {},
};

export default function moreFiltersReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case UPDATE_FILTER:
      return { ...state, moreFilters: payload };
    default:
      return state;
  }
}
